'use client';

import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { AuthProvider } from '@lib/context/AuthContext';
import { ReactNode } from 'react';
import { ProfileImageCacheProvider } from '@hooks/useProfileImageCache';

interface ProviderProps {
  children: ReactNode;
  session?: Session | null;
  authOptions?: {
    skipFetch?: boolean;
    skipServerVerification?: boolean;
    lightweightFetch?: boolean;
  };
}

export function Providers({ children, session, authOptions }: ProviderProps) {
  // Default to using lightweight fetch to reduce DB load
  const defaultAuthOptions = {
    lightweightFetch: true,
    ...authOptions
  };

  return (
    <SessionProvider session={session}>
      <AuthProvider authOptions={defaultAuthOptions}>
        <ProfileImageCacheProvider>
          {children}
        </ProfileImageCacheProvider>
      </AuthProvider>
    </SessionProvider>
  );
} 